import { Route } from "react-router-dom";
import WebsiteLayout from "../layout/WebsiteLayout";
import WebDashboard from "../components/views/website-dashboard/main.jsx";
import WebTreatmentCreate from "../components/views/website-dashboard/treatment/treatment_pages/treatmentCreatePage.jsx";
import WebTreatmentUpdate from "../components/views/website-dashboard/treatment/treatment_pages/treatmentUpdatePage.jsx";
import CmsTreatmentList from "../components/views/website-dashboard/cms_treatment/cms_treatment_list.jsx";
import CmsTreatmentCreate from "../components/views/website-dashboard/cms_treatment/cms_treatment_create.jsx";
import CmsTreatmentUpdate from "../components/views/website-dashboard/cms_treatment/cms_treatment_update.jsx";
import Promotion from "../components/views/website-dashboard/promotion/promo_pages/promo_list.jsx";
import PromotionCreate from "../components/views/website-dashboard/promotion/promo_pages/promo_create_page.jsx";
import PromotionUpdate from "../components/views/website-dashboard/promotion/promo_pages/promo.update_page.jsx";
import Banner from "../components/views/website-dashboard/banner/banner_pages/banner_list_page.jsx";
import BannerCreate from "../components/views/website-dashboard/banner/banner_pages/banner_create_page.jsx";
import BannerUpdate from "../components/views/website-dashboard/banner/banner_pages/banner_update_page.jsx";
import Branch from "../components/views/website-dashboard/branch/branch_pages/branch_list_page.jsx";
import BranchCreate from "../components/views/website-dashboard/branch/branch_pages/branch_create_page.jsx";
import BranchUpdate from "../components/views/website-dashboard/branch/branch_pages/branch_update_page.jsx";
import BranchDetail from "../components/views/website-dashboard/branch/branch_pages/branch_detail_page.jsx";
import StaffList from "../components/views/website-dashboard/staff/staff_pages/staff_list_page.jsx";
import StaffCreate from "../components/views/website-dashboard/staff/staff_pages/staff_create_page.jsx";
import StaffUpdate from "../components/views/website-dashboard/staff/staff_pages/staff_update_page.jsx";
import StaffDetail from "../components/views/website-dashboard/staff/staff_pages/staff_detail_page.jsx";
import Testimonial from "../components/views/website-dashboard/testimonial/testimonial_pages/testimonial_list_page.jsx";
import TestimonialCreate from "../components/views/website-dashboard/testimonial/testimonial_pages/testimonial_create_page.jsx";
import TestimonialUpdate from "../components/views/website-dashboard/testimonial/testimonial_pages/testimonial_update_page.jsx";
import TestimonialDetail from "../components/views/website-dashboard/testimonial/testimonial_pages/testimonial_detail_page.jsx";

const WebsiteRoutes = (
  <Route element={<WebsiteLayout />}>
    <>
      <Route path="/treatment-dashboard" element={<WebDashboard />} />
      <Route path="/treatment-create" element={<WebTreatmentCreate />} />
      <Route path="/treatment-update/:id" element={<WebTreatmentUpdate />} />
      <Route path="/cms-treatment" element={<CmsTreatmentList />} />
      <Route path="/cms-treatment-create" element={<CmsTreatmentCreate />} />
      <Route path="/cms-treatment-update/:id" element={<CmsTreatmentUpdate />} />
      <Route path="/promotion" element={<Promotion />} />
      <Route path="/promotion-create" element={<PromotionCreate />} />
      <Route path="/promotion-update/:id" element={<PromotionUpdate />} />
      <Route path="/banner" element={<Banner />} />
      <Route path="/banner-create" element={<BannerCreate />} />
      <Route path="/banner-update/:id" element={<BannerUpdate />} />
      <Route path="/branch" element={<Branch />} />
      <Route path="/branch-create" element={<BranchCreate />} />
      <Route path="/branch-update/:id" element={<BranchUpdate />} />
      <Route path="/branch-detail/:id" element={<BranchDetail />} />
      <Route path="/staff" element={<StaffList />} />
      <Route path="/staff-create" element={<StaffCreate />} />
      <Route path="/staff-update/:id" element={<StaffUpdate />} />
      <Route path="/staff-detail/:id" element={<StaffDetail />} />
      <Route path="/testimonial" element={<Testimonial />} />
      <Route path="/testimonial-create" element={<TestimonialCreate />} />
      <Route path="/testimonial-update/:id" element={<TestimonialUpdate />} />
      <Route path="/testimonial-detail/:id" element={<TestimonialDetail />} />
    </>
  </Route>
);

export default WebsiteRoutes;
